<template>
    <div @click="localSelected = value">
        <Badge
            class="pointer"
            :class="{'selected-badge': valueIsSelected}"
            tag="span"
            rounded>
            {{ label ? label : value }}
        </Badge>
    </div>
</template>

<script>

export default {
    name: "SelectableCategory",
    props: {
        value: {},
        label: {
            type: String
        },
        modelValue: {
            type: [Boolean, Array]
        }
    },
    computed: {
        localSelected: {
            get() {
                return this.modelValue
            },
            set(val) {
                if (typeof this.modelValue === "boolean") {
                    this.$emit('update:modelValue', !this.modelValue)
                } else if (Array.isArray(this.modelValue)) {
                    if (this.modelValue.includes(val)) {
                        this.$emit('update:modelValue', this.modelValue.filter(id => id !== val))
                    } else {
                        this.$emit('update:modelValue', [...this.modelValue, val].sort())
                    }
                }
            }
        },
        valueIsSelected() {
            if (typeof this.modelValue === "boolean") {
                return this.modelValue
            }
            if (Array.isArray(this.modelValue)) {
                return this.modelValue.includes(this.value)
            }
            return false
        }
    }
}
</script>

<style lang="scss" scoped>
.badge {
    text-transform: none;
    background-color: transparent;
    color: $input-color;
    box-sizing: border-box;
    border: .5px solid $input-border-color;
    font-size: .8rem;
    font-weight: 500;

    &:hover {
        background-color: $gray-100;
        color: $dark;
    }
}

.selected-badge {
    background-color: var(--category-background);
    color: var(--category-text) !important;
    border: 1px solid transparent;
    opacity: 0.65;

    &:hover {
        background-color: var(--category-background);
        opacity: 1;
    }
}
</style>
